import { useTranslation } from "react-i18next";

export type SchoolTranslate = (key: string) => string;

export const useSchoolLocal = () => {
  const { t, i18n } = useTranslation(["school"]);
  const isArabic = i18n.language === "ar";

  // i18next types results as `string | null`; every school key exists, so narrow it.
  const translate: SchoolTranslate = (key) => t(key) as string;
  // List keys hold arrays/objects, not strings.
  const translateObject = <T>(key: string) =>
    t(key, { returnObjects: true }) as T;

  return {
    t: translate,
    tObject: translateObject,
    isArabic,
    dir: isArabic ? "rtl" : "ltr",
    language: isArabic ? "ar" : "en",
    bodyFont: isArabic ? "font-ibmplex" : "font-inter",
    headingFont: isArabic ? "font-ibmplex" : "font-funnel",
  } as const;
};
